import React, { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import Heading from '../../../../generic-components/Heading';
import { SHARED_STYLES } from '../../consts';
import { WidgetLink } from '../../components/WidgetLink';
import { VIEWS_MAP } from '../../../../router/constants';
import { TransactionRow } from '../../components/TransactionRow';
import { DashboardContext } from '../../contexts/DashboardContext';
import { LatestTransactionsZeroState } from '../../components/LatestTransactionsZeroState';
import { TransactionsWidgetSkeleton } from '../../components/skeletons/TransactionsWidgetSkeleton';
import { trackMixPanel } from '../../../../services/mixpanel.service';
import { LiliTransaction } from '../../../TransactionsFacelift/types/lili-transaction';

export const testIdPrefix = 'latestTransactionsWidget';
export const LatestTransactionsWidget = ({ isLoading }: { isLoading: boolean }) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const context = useContext(DashboardContext);
  const hasLatestTransactions = context.latestTransactions?.length > 0;
  if (isLoading) return <TransactionsWidgetSkeleton />;
  const handleTransactionRowClick = (transaction: LiliTransaction) => {
    navigate(`/${VIEWS_MAP.TRANSACTIONS}?id=${transaction.transactionId}`);
  };
  const handleLinkClick = () => {
    trackMixPanel('Act on All Transactions - Dashboard');
  };
  return (
    <div className='p-[18px] flex flex-col'>
      <Heading testId={`${testIdPrefix}_title`} title={t('WIDGET_LATEST_TRANSACTIONS.TITLE')} className={`${SHARED_STYLES.widgetTitle} mb-[24px]`} />
      <div className='flex flex-col border-y-[1px] border-bw03 mb-[20px] h-[200px]'>
        {hasLatestTransactions && context.latestTransactions?.map((transaction) => <TransactionRow onClick={handleTransactionRowClick} liliTransaction={transaction} key={transaction?.transactionId} />)}
        {!hasLatestTransactions && <LatestTransactionsZeroState />}
      </div>
      {hasLatestTransactions && (
        <div className='w-full flex justify-end'>
          <WidgetLink
            linkTitle={t('WIDGET_LATEST_TRANSACTIONS.BUTTON')}
            linkUrl={`/${VIEWS_MAP.TRANSACTIONS}`}
            testId={`${testIdPrefix}_manage-link`}
            onClick={handleLinkClick}
          />
        </div>
      )}
    </div>
  );
};
